module.exports = __webpack_public_path__ + "static/media/acc_calc.6e60248a.svg";